import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "productManage",
  "use": "productManage-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"productManage\"><defs><style>#productManage .cls-1{fill:none}</style></defs><title>资源 50</title><g id=\"productManage_图层_2\" data-name=\"图层 2\"><g id=\"productManage_图层_1-2\" data-name=\"图层 1\"><path id=\"productManage_Rectangle_48_Copy_37\" data-name=\"Rectangle 48 Copy 37\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"productManage_sharealt\"><path id=\"productManage_Shape\" d=\"M15.57 19v-.23l-5.7-4a4.64 4.64 0 1 1-1.09-6.51 5.51 5.51 0 0 1 .68.6l6.19-3.12a3.94 3.94 0 0 1-.08-.74 3.46 3.46 0 1 1 .85 2.28l-6 3a4.65 4.65 0 0 1 .2 2.9l5.54 3.92a3.46 3.46 0 1 1-.6 1.9z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/productManage.svg
// module id = z19k
// module chunks = 6